import { Genre, Intro } from '../../../general/apiScenarios';
import { BaseTableColumn, BLTeam, MessagesInterface } from '../../../general/model';
import { CreativeFolderStrict } from '../../../general/modelCreativeFolder';
import { Type } from '../../../general/modules/filter/dataModel';
import { CHNode, NodeLabel } from '../../../general/node';
import { SortByInterface } from '../../../general/utils/useSort';
import { SearchParams } from '../search/model';

export enum Column {
  selector = 'selector',
  conversion_status = 'conversion_status',
  team = 'team',
  mislead_level = 'mislead_level',
  manager = 'manager',
  developer = 'developer',
  name = 'name',
  size = 'size',
  created_at = 'created_at',
  updated_at = 'updated_at',
  breadcrumbs = 'breadcrumbs',
  genre = 'genre',
  intro = 'intro',
  recognition = 'recognition',
  tags = 'tags',
  creative_name = 'creative_name',
}

// export const FilterableColumnIDs: Column[] = [
//   Column.mislead_level,
//   Column.size,
//   Column.name,
//   Column.created_at,
//   Column.updated_at,
//   Column.conversion_manager,
//   Column.conversion_status,
// ];

export const Messages = {
  loadNodesError: () => ({
    title: 'Folder not available',
    message:
      'Folder not exist or you have no permission to open it. Contact your administrator or support chat.',
  }),
  loadNodesInvalid: () => ({
    title: 'Server request error',
    message: 'Response contains invalid node type',
  }),
} as MessagesInterface;

export enum ConversionStatusCode {
  creative_ok = 'creative_ok',
  folder_contains_prohibited_items = 'folder_contains_prohibited_items',
  creative_contains_files_with_invalid_name = 'creative_contains_files_with_invalid_name',
  creative_is_ready_for_conversion = 'creative_is_ready_for_conversion',
  creative_contains_errors_in_naming = 'creative_contains_errors_in_naming',
  its_not_creative_folder = 'its_not_creative_folder',
  not_allowed_localization_folder_name = 'not_allowed_localization_folder_name',
  not_allowed_folder = 'not_allowed_folder',
}
export type ConversionState = {
  status: 'ERROR' | 'READY' | 'DONE';
  message: ConversionStatusCode;
  errors: string[];
  manager_full_name: string;
};

export const conversionStatusTranslations: Record<
  ConversionStatusCode,
  { full: string; short: string }
> = {
  creative_contains_files_with_invalid_name: {
    full: 'Creative contains files with invalid name',
    short: 'Invalid name',
  },
  creative_ok: { full: 'Creative OK', short: 'OK' },
  folder_contains_prohibited_items: {
    full: 'Folder contains prohibited items',
    short: 'Prohibited items',
  },
  creative_contains_errors_in_naming: {
    full: 'Creative contains erorrs in naming',
    short: 'Errors in naming',
  },
  its_not_creative_folder: { full: 'Item is not a creative folder', short: 'Not creative' },
  not_allowed_localization_folder_name: {
    full: 'Not allowed localization folder name',
    short: 'Localization error',
  },
  not_allowed_folder: { full: 'Not allowed folder', short: 'Folder error' },
  creative_is_ready_for_conversion: {
    full: 'Creative is ready for conversion',
    short: 'Creative ready',
  },
};
export interface FileManagerRow extends CHNode {
  conversionState: ConversionState | null;
  creative: CreativeFolderStrict | null;
  searchParamsContext: SearchParams | null;
  creative_name?: string | null;
}

export type FMColumn<T extends Type> = BaseTableColumn<T, Column, FileManagerRow>;
export type AnyFMColumn =
  | FMColumn<Type.NONE>
  | FMColumn<Type.STRING>
  | FMColumn<Type.ID>
  | FMColumn<Type.DATE>
  | NumericalFMColumn;

export type NumericalFMColumn =
  | FMColumn<Type.BYTES>
  | FMColumn<Type.FLOATING>
  | FMColumn<Type.INTEGER>
  | FMColumn<Type.MONETARY>
  | FMColumn<Type.PERCENTAGE>;

export type FileManagerShape = {
  inProgress: boolean;
  nodes: FileManagerRow[];
  creativeMisleadStatusWarnings: number[];
  selectedNodesByFolderID: Record<number, CHNode[]>;
  foldersByID: Record<number, NodeLabel>;
  sortBy: SortByInterface;
  columnToggles: Partial<Record<Column, boolean>>;
  blTeams: BLTeam[] | null;
  firstNodeIDSelected: null | number;
  lastNodeIDSelected: null | number;
  blLoading: boolean;
  genres: Genre[];
  intros: Intro[];
};

export function CHNodeToFileManagerRow<AdditionalFields>(
  chn: CHNode & AdditionalFields,
): FileManagerRow & AdditionalFields {
  return { ...chn, conversionState: null, creative: null, searchParamsContext: null };
}

const SESSIONSTOR_KEY = 'chFileManagerScrolls';

export const scrollSet = (scrollTop: number) => {
  const id = window.location.hash;
  const item = sessionStorage.getItem(SESSIONSTOR_KEY);
  const itemObject = item ? JSON.parse(item) : {};
  sessionStorage.setItem(SESSIONSTOR_KEY, JSON.stringify({ ...itemObject, [id]: scrollTop }));
};
export const scrollGet = () => {
  const id = window.location.hash;
  const item = sessionStorage.getItem(SESSIONSTOR_KEY);
  const itemObject: Record<string, string> = item ? JSON.parse(item) : {};

  return itemObject[id] ? parseInt(itemObject[id], 10) : 0;
};

export const scrollReset = () => sessionStorage.removeItem(SESSIONSTOR_KEY);

export type FileSizeObject = { value: number; symbol: string; exponent: number; unit: string };
